export default __webpack_public_path__ + "static/media/webswords.198a5d97.png";